const EDGE_COLOR_DEFAULT = "#303132";
const EDGE_COLOR_SUB_PROCESS = "#909295";

const normalizeLabel = (label) => String(label ?? "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const hexToRgb = (hex) => {
    const normalized = String(hex ?? "").trim();
    const match = /^#?([0-9a-f]{6})$/i.exec(normalized);
    if (!match) return null;
    const value = match[1];
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return { r, g, b };
};

// WCAG-ish relative luminance; input is 0..255
const relativeLuminance = ({ r, g, b }) => {
    const srgb = [r, g, b].map((v) => {
        const x = v / 255;
        return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
    });
    return (0.2126 * srgb[0]) + (0.7152 * srgb[1]) + (0.0722 * srgb[2]);
};

const SUB_PROCESS_LABEL = normalizeLabel("sub_process");

export const getEdgeLabelThemeFromColor = (edgeColor) => {
    const normalized = String(edgeColor ?? "").trim();
    const rgb = hexToRgb(normalized);
    const safeEdgeColor = rgb ? `#${normalized.replace(/^#/, "").toUpperCase()}` : EDGE_COLOR_DEFAULT;
    const lum = rgb ? relativeLuminance(rgb) : 0;
    const textColor = lum > 0.6 ? "#111827" : "#FFFFFF";
    return { edgeColor: safeEdgeColor, bgColor: safeEdgeColor, textColor, borderColor: safeEdgeColor };
};

export const getEdgeTypeColor = (label) => {
    const normalized = normalizeLabel(label);
    if (!normalized) return EDGE_COLOR_DEFAULT;
    if (normalized === SUB_PROCESS_LABEL) return EDGE_COLOR_SUB_PROCESS;
    return EDGE_COLOR_DEFAULT;
};
